import Head from "@helper/seo/head";
import React from "react";
import Layout from "@/landing/template/faq";
import getContents from "@helper/util/landing/getContents";

function Landing() {
  const { contents, language } = getContents();
  return (
    <>
      <Head
        title="SellOn | FAQ"
        catchme=""
      />
      <Layout contents={contents} language={language} />
    </>
  );
}

export default Landing;
